import React, {Component, Fragment} from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import * as R from "ramda";
import {getValueFromDDL, removeNullFields} from "../../../common/mapper";
import SimpleInput from "../../../../modules/SimpleInput";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {initialData, tableColumns} from "./config";
import OnSamsatAcceptanceFilter from "./onSamsatAcceptanceFilter";
import OnSamsatAcceptanceModifying from "./onSamsatAcceptanceModifying";
import Api from "../../../../Services/Api";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";

class OnSamsatAcceptance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            filterModalVisible: false,
            modifyingModalVisible: false,
            tableColumns: [
                ...tableColumns.mainPage,
                {
                    name: "",
                    label: "Action",
                    options: {
                        customBodyRender: (_, tableMeta) => {
                            return (
                                <FlexView vAlignContent="center">
                                    <SimpleButton
                                        category="action_button"
                                        style={{backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}}
                                                 className="fa fa-lw fa-pencil-alt"/>}
                                        onClick={() => this.handleModifyingModalVisibility(tableMeta.rowIndex)}
                                    />
                                </FlexView>
                            );
                        },
                        sort: false,
                    },
                },
            ],
            search: {...initialData.search},
            filterData: {...initialData.filter},
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
            },
            saveData: false,
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.setState((prevState) => ({
            ...prevState,
            search: {...prevState.search, kodeCabang: this.props.selectedCabang}
        }));

        await this.fetchData({
            ...removeNullFields(this.parseFilterData(this.state.search)),
            limit: this.state.pagination.limit,
            page: 1
        });
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (this.props.selectedCabang !== prevProps.selectedCabang) {
            this.handleTriggerLoading();
            await this.setState((prevState) => ({
                ...prevState,
                search: {...initialData.search, kodeCabang: this.props.selectedCabang},
                filterData: initialData.filter,
                pagination: {
                    count: 0,
                    limit: 1,
                    page: 1,
                },
            }))

            await this.fetchData({
                ...removeNullFields(this.parseFilterData(this.state.search)),
                limit: 5,
                page: 1,
            });
            this.handleTriggerLoading();
        }
        if (this.state.saveData && !this.state.modifyingModalVisible) {
            this.handleTriggerLoading();
            await this.setState((prevState) => ({
                ...prevState,
                search: {...initialData.search, kodeCabang: this.props.selectedCabang},
                filterData: initialData.filter,
                pagination: {
                    count: 0,
                    limit: 1,
                    page: 1,
                },
                saveData: false,
            }));
            await this.fetchData();
            this.handleTriggerLoading();
        }
    }

    handleModalFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            selectedCabang: this.state.search.kodeCabang,
            filterModalVisible: !prevState.filterModalVisible,
        }));
    };

    handleModifyingModalVisibility = async (index) => {
        this.handleTriggerLoading();
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: !R.isNil(index) ? prevValue.dataTable[index] : null,
            modifyingModalVisible: !prevValue.modifyingModalVisible,
        }));
        this.handleTriggerLoading();
    };

    handleValueChangeSearch = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleClearSearch = async (clearSearchFromFilter) => {
        this.handleTriggerLoading();
        this.setState((prevState) => ({
          ...prevState,
          search: {
            ...prevState.search,
            ...initialData.search,
            kodeCabang: this.props.selectedCabang,
          },
          pagination:{
            limit: 5,
            page: 1,
            totalData: 0,
          },
          filterData: {
            ...prevState.filterData,
            ...initialData.filter,
          }
        }),async ()=>{
            await this.fetchData();
            this.handleTriggerLoading();
        });
    }

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        let requestBody = {
            ...removeNullFields(this.parseFilterData(this.state.search)),
            limit: 5,
            page: 1
        }

        this.handleClearFilter(true);
        await this.fetchData(requestBody);
        this.handleTriggerLoading();
    }

    handleFilterValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleClearFilter = (isResetPagination) => {
        this.setState((prevState) => ({
          ...prevState,
          filterData: {
            ...prevState.filterData,
            ...initialData.filter,
          },
          pagination: {
            ...prevState.pagination,
            count: isResetPagination ? 0 : prevState.pagination.count,
          },
        }));
    }

    handleOnSubmitFilter = async () => {
        this.handleTriggerLoading()

        let filterData = {
            ...this.state.filterData,
            listVariant: this.filterAllOption(this.state.filterData.listVariant),
            listWarna: this.filterAllOption(this.state.filterData.listWarna),
        };

        const requestBody = {
            ...removeNullFields(this.parseFilterData(filterData)),
            kodeCabang: this.state.search.kodeCabang?.value,
            limit: 5,
            page: 1,
        };

        await this.fetchData(requestBody);
        this.setState((prevState) => ({
          ...prevState,
          search: {
            ...prevState.search,
            ...initialData.search,
            kodeCabang: this.props.selectedCabang,
          }
        }));
        this.handleModalFilterVisibility();
        this.handleTriggerLoading()
    }

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));

        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest, kodeCabang: this.state.search.kodeCabang.value};
        } else {
            paramFilters = {...searchRequest};
        }

        const reqBody = {
            ...paramFilters,
            page: page,
            limit: limit
        }

        await this.fetchData(reqBody);
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                count: 0,
                page: 1,
                limit: limit,
            }
        }));

        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest, kodeCabang: this.state.search.kodeCabang.value};
        } else {
            paramFilters = {...searchRequest};
        }

        const reqBody = {
            ...paramFilters,
            page: 1,
            limit: limit
        }

        await this.fetchData(reqBody);
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    triggerRefetch = () => {
        this.setState((prevValue) => ({...prevValue, saveData: true}));
    }

    parseFilterData(data) {
        return {
            ...data,
            kodeCabang: getValueFromDDL(data, "kodeCabang"),
            statusSTNK: getValueFromDDL(data, "statusSTNK"),
            statusBPKB: getValueFromDDL(data, "statusBPKB"),
            statusPlat: getValueFromDDL(data, "statusPlat"),
            statusPajak: getValueFromDDL(data, "statusPajak"),
            kodeVariant: data["kodeVariant"]?.map(({value}) => value),
            kodeWarna: data["kodeWarna"]?.map(({value}) => value),
        };
    }

    filterAllOption = (array) => {
        if (Array.isArray(array) && !R.isEmpty(array)) {
            return array.some(({value}) => R.equals(value, "ALL"))
                ? array.filter(({value}) => R.equals(value, "ALL"))
                : array;
        }
        return array;
    };

    fetchData = async (body) => {
        let req =
            body && Object.keys(body).length > 0 ?
                body :
                {
                    kodeCabang: this.props.selectedCabang?.value,
                    page: 1,
                    limit: 5,
                };
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").findAllReceivingSamsat,
            menuName: "Process Samsat",
            setError: this.props.setError,
            args: req,
        });

        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: response.data.data,
                pagination: {
                    count: response.data.totalData,
                    limit: req.limit,
                    page: req.page,
                }
            }));
        }
    }

    render() {
        console.log(this.state.pagination)
        return (
            <>
                <FlexView vAlignContent="center" hAlignContent="right" style={{marginBottom: "20px"}}>
                    <SimpleInput
                        type="text"
                        name="namaSTNK"
                        placeholder="Nama STNK"
                        containerclassname="margin-bottom-none"
                        value={this.state.search.namaSTNK}
                        onChange={(e) => this.handleValueChangeSearch(e.target.name, e.target.value)}
                    />
                    <SimpleButton
                        text="Cari"
                        onClick={this.handleSubmitSearch}
                        className="margin-top-5px"
                    />
                    <SimpleButton
                        text="Reset"
                        onClick={() => this.handleClearSearch(false)}
                        className="margin-top-5px"
                    />
                    <SimpleButton
                        className={"btn background-red margin-top-5px"}
                        styles={{width: "unset"}}
                        onClick={this.handleModalFilterVisibility}
                        icon={<i className="fa fa-qrcode"></i>}
                    />
                </FlexView>

                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableColumns}
                    toCount={this.state.pagination.count}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(
                        (tableState) => this.handleChangePage(tableState),
                        (tableState) => this.handleChangeRowsPerPage(tableState),
                    )}
                />

                {this.state.filterModalVisible && (
                    <OnSamsatAcceptanceFilter
                        selectedData={this.state.filterData}
                        selectedCabang={this.props.selectedCabang}
                        visible={this.state.filterModalVisible}
                        onValueChange={this.handleFilterValueChange}
                        onSubmit={this.handleOnSubmitFilter}
                        onClearForm={this.handleClearFilter}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                {this.state.modifyingModalVisible && (
                    <OnSamsatAcceptanceModifying
                        {...this.props}
                        selectedCabang={this.props.selectedCabang}
                        selectedData={this.state.selectedData}
                        visible={this.state.modifyingModalVisible}
                        onClickClose={this.handleModifyingModalVisibility}
                        triggerRefetch={this.triggerRefetch}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default OnSamsatAcceptance;